import { Badge } from "@mantine/core";
import { useMemo } from "react";
import type { CorrectionQueueItem } from "../../services/correctionRequestService";

interface Props {
  status: CorrectionQueueItem["status"];
}

export function CorrectionStatusBadge({ status }: Props) {
  const statusConfig = useMemo(() => {
    const map: Record<string, { color: string; label: string }> = {
      corrected: { color: "green", label: "Corrected" },
      pending: { color: "orange", label: "Pending" },
      applied: { color: "green", label: "Applied" },
      modified_and_applied: { color: "teal", label: "Modified & Applied" },
      discarded: { color: "gray", label: "Discarded" },
    };
    return map[status] ?? { color: "gray", label: status };
  }, [status]);

  return (
    <Badge color={statusConfig.color} size="sm" variant="light">
      {statusConfig.label}
    </Badge>
  );
}
